<template>
    <div class="cta" :class="classes">

        <template v-if="isMobile">
            <a href="" @click.prevent="mobileShareCta()"><span class="icon-share-2"></span>
                Partager</a>
        </template>


        <template v-else>
            <a @click.prevent="desktopFacebook()"><span class="icon-fb"></span></a>
            <a @click.prevent="desktopTwitter()"><span class="icon-twitter"></span></a>
            <a @click.prevent="shareMail()"><span class="icon-mail"></span></a>
            Partager
        </template>
        <transition>
            <div class="share-modal" v-if="mobileModalShow">
                <span class="icon-fb" @click="mobileFacebook()"></span>
                <span class="icon-mail" @click="shareMail(true)"></span>
                <span class="icon-twitter" @click="desktopTwitter(true)"></span>
            </div>
        </transition>


    </div>
</template>

<script>
import shareFunctions from '../../mixins/shareFunctions'
    export default {
        mixins: [shareFunctions],
        computed: {
            isMobile() {
                return this.$root.isMobile;
            },
            classes() {
                return this.isMobile ? 'partager-mobile' : 'partager';
            }
        },
        methods: {

        }
    };
</script>




// WEBPACK FOOTER //
// assets/js/components/cruise-product/ShareCruise.vue